import { backendApi } from "@/services/api";
import { Filter } from "@/shared/lib/filter/filter";
import { Documentation } from "./documentation";

const documentationsApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    createDocumentation: build.mutation<Response, CreateRequest>({
      query: (request) => ({
        url: `/inspections/documentations`,
        method: "POST",
        body: request,
      }),
      invalidatesTags: ["Documentations", "Delivery"],
    }),
    putDocumentation: build.mutation<Response, PutRequest>({
      query: (request) => ({
        url: `/inspections/documentations`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: ["Documentations"],
    }),
    showDocumentationForProcess: build.query<Response, ShowForProcessRequest>({
      query: (request) => ({
        url: `/inspections/documentations/show-for-process/${request.processId}`,
        method: "GET",
      }),
      providesTags: (_result, _e, request) => [
        { type: "Documentations", id: request.processId },
      ],
    }),
    showDocumentation: build.query<Response, ShowRequest>({
      query: (request) => ({
        url: `/inspections/documentations/${request.id}`,
        method: "GET",
      }),
      providesTags: (_result, _e, request) => [
        { type: "Documentations", id: request.id },
      ],
    }),
    listDocumentations: build.query<List, ListRequest>({
      query: (request) => ({
        url: `/inspections/documentations`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
      providesTags: ["Documentations"],
    }),
  }),
});

export const {
  useCreateDocumentationMutation,
  useShowDocumentationQuery,
  useShowDocumentationForProcessQuery,
  usePutDocumentationMutation,
  useListDocumentationsQuery,
} = documentationsApi;

export interface Response {
  documentation: Documentation;
}

export interface CreateRequest {
  id: string;
  processId: string;
  customerId: string;
  deliveryId: string;
  createdBy: string;
}

export interface PutRequest {
  documentation: Documentation;
}

export interface ShowRequest {
  id: string;
}

export interface ShowForProcessRequest {
  processId: string;
}

export interface ListRequest {
  processId?: Filter<string>;
  ownerId?: Filter<string>;
  ownerType?: Filter<string>;
  limit: number;
  offset: number;
}

export interface List {
  count: number;
  items: Documentation[];
}
